import * as React from "react";
import { connect } from "react-redux";

import ItemCategory from "../../screens/Settings/ItemCategory";
import {
  itemCategorylist,
  AddItemCategory,
  EditItemCategory,
  DeleteItemCategory,
  itemCategorySlectedPage
} from "./action";
class ItemCategoryContainer extends React.Component<Props, State> {
  render() {
    return (
      <ItemCategory
        itemCategorylist={this.props.itemCategorylist}
        itemCategoryList={this.props.itemCategoryList}
        itemCategoryCount={this.props.itemCategoryCount}
        AddItemCategory={this.props.AddItemCategory}
        EditItemCategory={this.props.EditItemCategory}
        DeleteItemCategory={this.props.DeleteItemCategory}
        itemCategorySlectedPage={this.props.itemCategorySlectedPage}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    itemCategorylist: () => {
      dispatch(itemCategorylist());
    },
    AddItemCategory: value => {
      // console.log(value);
      dispatch(AddItemCategory(value));
    },
    EditItemCategory: value => {
      // console.log(value);
      dispatch(EditItemCategory(value));
    },
    DeleteItemCategory: value => {
      dispatch(DeleteItemCategory(value));
    },
    itemCategorySlectedPage: value => {
      dispatch(itemCategorySlectedPage(value));
    }
  };
}
const mapStateToProps = state => {
  return {
    itemCategoryList: state.ItemCategoryReducer.itemCategoryList,
    itemCategoryCount: state.ItemCategoryReducer.itemCategoryCount
  };
};

export default connect(
  mapStateToProps,
  bindAction
)(ItemCategoryContainer);
